// src/views/Admin/Questions/QuestionList.js
import {
  Card,
  CardHeader,
  Table,
  Container,
  Row,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import Header from "components/Headers/Header.js";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { getSurveyQuestionList } from "services/_survey";
import { errorToast } from "components/toast";
import "react-quill/dist/quill.snow.css";
import { getPermissions } from "context/AuthContext";

const QuestionList = () => {
  const permissions = getPermissions();
  console.log("Permissions:", permissions);
  const navigate = useNavigate();
  const [questions, setQuestions] = useState([]);

  // Fetch all questions (no pagination)
  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        const data = await getSurveyQuestionList();
        if (data.data) {
          const allQuestions = data.data.records || [];
          setQuestions(allQuestions);
        }
      } catch (err) {
        console.error(err);
        errorToast("Failed to fetch questions");
      }
    };
    fetchQuestions();
  }, []);

  // Navigate to edit page and pass question object via state
  const handleEdit = (question) => {
    navigate(`/admin/questions/edit-question`, { state: question });
  };

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                <h3>Survey Questions</h3>
              </CardHeader>
              <Table
                className="align-items-center table-flush"
                responsive
                style={{ tableLayout: "auto", width: "100%" }}
              >
                <thead className="thead-light">
                  <tr>
                    <th style={{ width: "50px" }}>#</th>
                    <th>Question Text</th>
                    <th>Question (short form)</th>
                    {permissions.includes("update-question") && (
                      <th style={{ width: "100px" }} />
                    )}
                  </tr>
                </thead>
                <tbody>
                  {questions.length > 0 ? (
                    questions.map((q, index) => (
                      <tr key={q.id || index}>
                        <th
                          scope="row"
                          style={{
                            width: "50px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                          }}
                        >
                          {index + 1}
                        </th>
                        <td
                          style={{
                            whiteSpace: "normal",
                            wordWrap: "break-word",
                            maxWidth: "600px",
                          }}
                          dangerouslySetInnerHTML={{ __html: q.question }}
                        />
                        <td
                          style={{
                            whiteSpace: "normal",
                            wordWrap: "break-word",
                            maxWidth: "300px",
                          }}
                        >
                          {q.symptoms}
                        </td>
                        {permissions.includes("update-question") && (
                          <td className="text-center">
                            <UncontrolledDropdown>
                              <DropdownToggle
                                className="btn-icon-only text-light"
                                href="#pablo"
                                role="button"
                                size="sm"
                                color=""
                                onClick={(e) => e.preventDefault()}
                              >
                                <i className="fas fa-ellipsis-v" />
                              </DropdownToggle>
                              <DropdownMenu
                                className="dropdown-menu-arrow"
                                right
                              >
                                <DropdownItem onClick={() => handleEdit(q)}>
                                  <i
                                    className="fas fa-edit"
                                    style={{
                                      color: "#1976d2",
                                      cursor: "pointer",
                                      marginRight: "10px",
                                    }}
                                  />
                                  Edit
                                </DropdownItem>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </td>
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className="text-center">
                        No questions found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
              {/* Pagination removed */}
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default QuestionList;
